import { useEffect } from 'react';

import { isRouteErrorResponse, useRouteError } from 'react-router';

import { logErrorMini } from '@/shared/services/service-logger/lib/log-error-mini';
import { ErrorPage } from '@/shared/ui/error-page/ErrorPage';

export const RouterErrorPage = () => {
  const error = useRouteError();

  let message = 'Router error';

  console.log('ERROROROROR', error);

  if (error) {
    if (isRouteErrorResponse(error)) {
      message = error.statusText;
    } else {
      message = (error as any).message ?? error;
    }
  }

  useEffect(() => {
    if (error) {
      logErrorMini(message, (error as any).status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!error]);

  if (!error) return null;

  return <ErrorPage message={message} />;
};
